module.exports = __webpack_public_path__ + "img/dsci0045.1e78831d.jpg";